export default "__VITE_ASSET__Br_MOAet__"